<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Search page content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label title="Ask Mohammad to fill in this field">Custom search engine id "cx":</label>
          <input placeholder="Ask Mohammad to fill in this field" type="text" class="form-control"
            v-model="fit20.blockToEdit.cx" />
        </div>
        <div class="field-sec">
          <label>Search placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.placeholder" />
        </div>
        <div class="field-sec">
          <label>No results text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.no_results" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'Search',
  props: ["fit20", "saveBlock", "cancelEditing"],

};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}
</style>
